// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"fQ-z","sponsoredTooltipWrapper":"gQ-z","sponsoredTooltip":"hQ-z","newCard":"iQ-z"};